import R from 'ramda'

const GOOGLE_ANALYTICS_TRACK_EVENT_ACTION_TYPE = 'GOOGLE_ANALYTICS_TRACK_EVENT'
const GOOGLE_ANALYTICS_TRACK_EVENT_DISPLAY_TYPE = 'Google Analytics Track Event'

const isGoogleAnalyticsTrackEventFormAction = R.propEq(
  'type',
  GOOGLE_ANALYTICS_TRACK_EVENT_DISPLAY_TYPE
)

const convertGoogleAnalyticsTrackEventFormActionToWidgetAction = R.applySpec({
  type: R.always(GOOGLE_ANALYTICS_TRACK_EVENT_ACTION_TYPE),
  eventCategory: R.prop('eventCategory'),
  eventAction: R.prop('eventAction'),
  eventLabel: R.prop('eventLabel')
})

export {
  isGoogleAnalyticsTrackEventFormAction,
  convertGoogleAnalyticsTrackEventFormActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/google-analytics-track-event.js